import i18n, { initializeI18n } from "@vrf/fr-vrf-i18n-react";
import { ScreenMessageEnUs } from "./messages/screen-message-en-US";

export const EN_US = "en_US";

const localeResource = [{ locale: EN_US, resource: ScreenMessageEnUs }];

const fallbackLogic = () => EN_US;

initializeI18n(localeResource, fallbackLogic);

export default i18n;
